export default {
  EL: {
    TXTCLI_Announced: 'Ανακοινώθηκε',
    TXTCLI_Average_Stack: 'Μέσο stack',
    TXTCLI_Blinds: 'Blinds',
    TXTCLI_Clear: 'Καθαρισμός',
    TXTCLI_Completed: 'Ολοκληρώθηκε',
    TXTCLI_Current_Level: 'Τρέχον επίπεδο',
    TXTCLI_Days: 'Ημέρες',
    TXTCLI_First_Prize: 'Πρώτο έπαθλο',
    TXTCLI_Games: 'Παιχνίδια',
    TXTCLI_Hours: 'ώρες',
    TXTCLI_Late_Registration: 'Καθυστερημένη εγγραφή',
    TXTCLI_Late_regX_ends_in: 'Οι καθυστερημένες εγγραφές λήγουν σε',
    TXTCLI_LoadingXX: 'Φορτώνει...',
    TXTCLI_Lobby: 'Λόμπι',
    TXTCLI_Mins: 'λεπτά',
    TXTCLI_N0_BUY_IN: '%0 BUY-IN',
    TXTCLI_N0_days_1_hour: '%0 ημέρες 1 ώρα',
    TXTCLI_N0_days: '%0 ημέρες',
    TXTCLI_Places_paid: 'Θέσεις που πληρώνονται',
    TXTCLI_Places_Paid: 'Θέση σε έπαθλα',
    TXTCLI_Players: 'Παίκτες',
    TXTCLI_PRIZE_POOL___N0: 'PRIZE POOL - %0',
    TXTCLI_Prize_Pool: 'Συνολικό Έπαθλο',
    TXTCLI_Register__toTournament: 'Εγγραφή',
    TXTCLI_Registering: 'Ανοιχτές εγγραφές',
    TXTCLI_Running_for: 'Τρέχει για',
    TXTCLI_Running: 'Σε εκτέλεση',
    TXTCLI_Secs: 'Δευτερόλεπτα',
    TXTCLI_StartedX: 'Ξεκίνησε:',
    TXTCLI_Starting_Chips: 'Μάρκες Εκκίνησης',
    TXTCLI_Total_players_2: 'Σύνολο παικτών',
    TXTMOB_BB: 'BB',
    TXTMOB_Buy_inX: 'Buy-in:',
    TXTWCL_CompletedX: 'Ολοκληρώθηκε:'
  },
  FR: {
    TXTCLI_Announced: 'Annoncé',
    TXTCLI_Average_Stack: 'Tapis moyen',
    TXTCLI_Blinds: 'Blinds',
    TXTCLI_Clear: 'Effacer',
    TXTCLI_Completed: 'Terminé',
    TXTCLI_Current_Level: 'Niveau actuel',
    TXTCLI_Days: 'Jours',
    TXTCLI_First_Prize: 'Premier prix',
    TXTCLI_Games: 'Parties',
    TXTCLI_Hours: 'heures',
    TXTCLI_Late_Registration: 'Inscription tardive',
    TXTCLI_Late_regX_ends_in: `Fin de l'insc. tardive dans`,
    TXTCLI_LoadingXX: 'En cours de chargement...',
    TXTCLI_Lobby: 'Lobby',
    TXTCLI_Mins: 'mins',
    TXTCLI_N0_BUY_IN: 'BUY-IN DE %0',
    TXTCLI_N0_days_1_hour: '%0 jours 1 heure',
    TXTCLI_N0_days: '%0 jours',
    TXTCLI_Places_paid: 'Places payées',
    TXTCLI_Places_Paid: 'Places payées',
    TXTCLI_Players: 'Joueurs',
    TXTCLI_PRIZE_POOL___N0: 'PRIZE POOL - %0',
    TXTCLI_Prize_Pool: 'Prize pool',
    TXTCLI_Register__toTournament: `S'inscrire`,
    TXTCLI_Registering: "S'inscrire",
    TXTCLI_Running_for: 'En cours depuis',
    TXTCLI_Running: 'En cours',
    TXTCLI_Secs: 'Secondes',
    TXTCLI_StartedX: 'Commencé:',
    TXTCLI_Starting_Chips: 'Jetons de départ',
    TXTCLI_Total_players_2: 'Nombre de joueurs',
    TXTMOB_BB: 'BB',
    TXTMOB_Buy_inX: 'Buy-in:',
    TXTWCL_CompletedX: 'Terminé:'
  },
  IT: {
    TXTCLI_Announced: 'Annunciato',
    TXTCLI_Average_Stack: 'Stack medio',
    TXTCLI_Blinds: 'Blind',
    TXTCLI_Clear: 'Pulisci',
    TXTCLI_Completed: 'Completato',
    TXTCLI_Current_Level: 'Livello attuale',
    TXTCLI_Days: 'Giorni',
    TXTCLI_First_Prize: 'Primo premio',
    TXTCLI_Games: 'Giochi',
    TXTCLI_Hours: 'ore',
    TXTCLI_Late_Registration: 'Registrazione tardiva',
    TXTCLI_Late_regX_ends_in: 'Termine reg. tardiva',
    TXTCLI_LoadingXX: 'Caricamento...',
    TXTCLI_Lobby: 'Lobby',
    TXTCLI_Mins: 'minuti',
    TXTCLI_N0_BUY_IN: 'BUY-IN DI %0',
    TXTCLI_N0_days_1_hour: '%0 giorni e 1 ora',
    TXTCLI_N0_days: '%0 giorni',
    TXTCLI_Places_paid: 'Posizioni a premio',
    TXTCLI_Places_Paid: 'Posti pagati',
    TXTCLI_Players: 'Gioc.',
    TXTCLI_PRIZE_POOL___N0: 'MONTEPREMI: %0',
    TXTCLI_Prize_Pool: 'Montepremi',
    TXTCLI_Register__toTournament: 'Registra',
    TXTCLI_Registering: 'Registrazione',
    TXTCLI_Running_for: 'In corso da',
    TXTCLI_Running: 'In corso',
    TXTCLI_Secs: 'Secondi',
    TXTCLI_StartedX: 'Iniziato:',
    TXTCLI_Starting_Chips: 'Chips Iniziali',
    TXTCLI_Total_players_2: 'Totale giocatori',
    TXTMOB_BB: 'GB',
    TXTMOB_Buy_inX: 'Buy-in:',
    TXTWCL_CompletedX: 'Completato:'
  },
  JA: {
    TXTCLI_Announced: '予告中',
    TXTCLI_Average_Stack: '	平均スタック',
    TXTCLI_Blinds: 'ブラインド',
    TXTCLI_Clear: '取消し',
    TXTCLI_Completed: '終了',
    TXTCLI_Current_Level: '現在のレベル',
    TXTCLI_Days: '日',
    TXTCLI_First_Prize: '1 位の賞',
    TXTCLI_Games: 'ゲーム',
    TXTCLI_Hours: '時間',
    TXTCLI_Late_Registration: '途中参加',
    TXTCLI_Late_regX_ends_in: '途中参加締切まで',
    TXTCLI_LoadingXX: '読み込み中…',
    TXTCLI_Lobby: 'ロビー',
    TXTCLI_Mins: '分',
    TXTCLI_N0_BUY_IN: 'バイイン %0',
    TXTCLI_N0_days_1_hour: '%0 日と 1 時間',
    TXTCLI_N0_days: '%0 日',
    TXTCLI_Places_paid: '入賞順位',
    TXTCLI_Places_Paid: '入賞順位',
    TXTCLI_Players: '参加者',
    TXTCLI_PRIZE_POOL___N0: '賞金プール - %0',
    TXTCLI_Prize_Pool: '賞金プール',
    TXTCLI_Register__toTournament: '登録',
    TXTCLI_Registering: '参加受付中',
    TXTCLI_Running_for: '経過時間',
    TXTCLI_Running: 'プレイ中',
    TXTCLI_Secs: '秒',
    TXTCLI_StartedX: '開始:',
    TXTCLI_Starting_Chips: '開始時のチップ量',
    TXTCLI_Total_players_2: '総参加者数',
    TXTMOB_BB: 'BB',
    TXTMOB_Buy_inX: 'バイイン:',
    TXTWCL_CompletedX: '完了:'
  },
  RU: {
    TXTCLI_Announced: 'Объявлен',
    TXTCLI_Average_Stack: 'Средний стек',
    TXTCLI_Blinds: 'Блайнды %0/%1',
    TXTCLI_Clear: 'Дата оплаты',
    TXTCLI_Completed: 'Завершен',
    TXTCLI_Current_Level: 'Текущий уровень',
    TXTCLI_Days: 'дней',
    TXTCLI_First_Prize: 'Primo premio',
    TXTCLI_Games: 'игр(ы)',
    TXTCLI_Hours: 'ч',
    TXTCLI_Late_Registration: 'Поздняя регистрация',
    TXTCLI_Late_regX_ends_in: 'Termine reg. tardiva',
    TXTCLI_LoadingXX: 'Загрузка...',
    TXTCLI_Lobby: 'Лобби',
    TXTCLI_Mins: 'мин',
    TXTCLI_N0_BUY_IN: 'BUY-IN DI %0',
    TXTCLI_N0_days_1_hour: '%0 дн. 1 ч.',
    TXTCLI_N0_days: '%0 дн',
    TXTCLI_Places_paid: 'Lugares Pagos',
    TXTCLI_Places_Paid: 'Lugares Pagos',
    TXTCLI_Players: 'Игроки.',
    TXTCLI_PRIZE_POOL___N0: 'MONTEPREMI: %0',
    TXTCLI_Prize_Pool: 'Призовой фонд',
    TXTCLI_Register__toTournament: 'Зарегистрироваться',
    TXTCLI_Registering: 'Регистрац',
    TXTCLI_Running_for: 'Идет',
    TXTCLI_Running: 'Идёт',
    TXTCLI_Secs: 'Secondi',
    TXTCLI_StartedX: 'Начало:',
    TXTCLI_Starting_Chips: 'Стартовые фишки',
    TXTCLI_Total_players_2: 'Totale giocatori',
    TXTMOB_BB: 'GB',
    TXTMOB_Buy_inX: 'Buy-in:',
    TXTWCL_CompletedX: 'Completato:'
  }
};
